var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chatbox chatbox--tray chatbox--empty",
      attrs: { id: "chat-section" }
    },
    [
      _c(
        "div",
        { staticClass: "chatbox__title", on: { click: _vm.toggleChat } },
        [
          _c("h5", [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(
                _vm._s(
                  _vm.specialist_consultant
                    ? _vm.specialist_consultant
                    : _vm.$store.getters.t("specialist_consultant")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("button", { staticClass: "chatbox__title__close" }, [
            _c("span", [
              _c(
                "svg",
                {
                  attrs: { viewBox: "0 0 12 12", width: "12px", height: "12px" }
                },
                [
                  _c("line", {
                    attrs: {
                      stroke: "#FFFFFF",
                      x1: "11.75",
                      y1: "0.25",
                      x2: "0.25",
                      y2: "11.75"
                    }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      stroke: "#FFFFFF",
                      x1: "11.75",
                      y1: "11.75",
                      x2: "0.25",
                      y2: "0.25"
                    }
                  })
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.start
        ? [
            _c(
              "div",
              { staticClass: "chatbox__body", attrs: { id: "chat_box" } },
              [
                _vm._l(_vm.messages, function(message, index) {
                  return [
                    message.from != _vm.user
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "chatbox__body__message chatbox__body__message--left"
                          },
                          [
                            message.faq_translation_id
                              ? [
                                  _c("img", {
                                    staticClass: "chat-img",
                                    attrs: {
                                      src: "/images/support_img.png",
                                      alt: "Picture"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chat-bot-section" },
                                    [
                                      _vm.locale
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "answer-point",
                                              attrs: {
                                                href:
                                                  "/" +
                                                  message.faq_translations
                                                    .language.prefix +
                                                  "/faq#" +
                                                  message.faq_translations.slug
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  message.faq_translations
                                                    .question
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "router-link",
                                            {
                                              staticClass: "answer-point",
                                              attrs: {
                                                to:
                                                  "/" +
                                                  message.faq_translations
                                                    .language.prefix +
                                                  "/faq#" +
                                                  message.faq_translations.slug,
                                                tag: "a"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  message.faq_translations
                                                    .question
                                                ) + "\n                "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]
                              : [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/support_img.png",
                                      alt: "Picture"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(message.message))])
                                ]
                          ],
                          2
                        )
                      : _c(
                          "div",
                          {
                            key: index + _vm.key,
                            staticClass:
                              "chatbox__body__message chatbox__body__message--right"
                          },
                          [
                            _vm.photo
                              ? _c("img", {
                                  attrs: { src: _vm.photo, alt: "Picture" }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: "/images/men.jpg",
                                    alt: "Picture"
                                  }
                                }),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(message.message))])
                          ]
                        )
                  ]
                }),
                _vm._v(" "),
                _vm.faqs.length
                  ? _vm._l(_vm.faqs, function(faq, idx) {
                      return _c(
                        "div",
                        { key: "faq" + idx, staticClass: "chat-bot-section" },
                        [
                          _vm.locale
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "/" +
                                      _vm.locale +
                                      "/faq#" +
                                      faq.faq_transliations[0].slug
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(faq.faq_transliations[0].question)
                                  )
                                ]
                              )
                            : _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/" +
                                      _vm.$store.getters.locale +
                                      "/faq#" +
                                      faq.faq_transliations[0].slug,
                                    tag: "a"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(faq.faq_transliations[0].question) +
                                      "\n            "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message,
                  expression: "message"
                }
              ],
              staticClass: "chatbox__message",
              attrs: {
                placeholder: _vm.message_title
                  ? _vm.message_title
                  : _vm.$store.getters.t("message_title")
              },
              domProps: { value: _vm.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.message = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "send-message submit_button",
                on: {
                  click: function($event) {
                    return _vm.send()
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.send_title
                      ? _vm.send_title
                      : _vm.$store.getters.t("send")
                  ) + "\n      "
                )
              ]
            )
          ]
        : [
            _c(
              "form",
              {
                staticClass: "chatbox__credentials",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.startChat($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "inputName" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.name ? _vm.name : _vm.$store.getters.t("name")
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.name,
                        expression: "form.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "name",
                      id: "inputName",
                      required: ""
                    },
                    domProps: { value: _vm.form.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "inputEmail" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.email ? _vm.email : _vm.$store.getters.t("email")
                      ) + ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.email,
                        expression: "form.email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      name: "email",
                      id: "inputEmail",
                      required: ""
                    },
                    domProps: { value: _vm.form.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "email", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "submit_button", attrs: { type: "submit" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.send_title
                          ? _vm.send_title
                          : _vm.$store.getters.t("send")
                      )
                    )
                  ]
                )
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "chatbox__title__tray" }, [_c("span")])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1da70ece", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da70ece","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/support/SupportComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1da70ece","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/support/SupportComponent.vue
// module chunks = 0 3